import FuneralQuote from './FuneralQuote'

export default FuneralQuote
